import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { t } from 'ember-intl';
import { not, or } from 'ember-truth-helpers';

import Button from 'umg-ember-backend/components/ui/button';
import InfoBox from 'umg-ember-backend/components/ui/info-box';

export default class PageBuilderMainSettingsComponent extends Component {
  // Services
  @service recordStatus;

  // Getter and setter
  get isModelDisabledOrInvalid() {
    return this.recordStatus.isDisabledOrInvalid(this.args.form.model);
  }

  // Template
  <template>
    <div class='o-layout u-margin-bottom-large'>
      <div class='o-layout__item u-1/1'>
        <@form.field @property='headline' />

        {{#if @form.model.hasInvalidMainSettings}}
          <InfoBox @type='warning'>
            {{t 'record_detail.forms.mlp.main_settings.no_title_artist'}}
          </InfoBox>
        {{/if}}

        {{#unless @form.model.isNew}}
          <b>{{t 'record_detail.forms.mlp.main_settings.live_url'}}</b>
          {{#if @model.hasVisiblePublisheMlp}}
            <a
              href={{@form.model.liveUrl}}
              target='_blank'
              rel='noopener noreferrer'
            >
              {{@form.model.liveUrl}}
            </a>
          {{else}}
            {{t 'record_detail.forms.mlp.main_settings.not_publihsed'}}

            <Button
              @label={{t 'record_detail.toolbar.primary.publish'}}
              @style='danger'
              @size='small'
              @disabled={{or
                this.isModelDisabledOrInvalid
                (not @form.hasPermissionToEdit)
              }}
              {{on 'click' @publish}}
            />
          {{/if}}
        {{/unless}}
      </div>
    </div>
  </template>
}
